<template>
  <div :class="joinClasses('form-row', modifiers)">
    <div class="form-row__fields">
      <label v-if="label" :for="labelFor" class="form-row__label typo-input">{{ label }}</label>
      <div class="form-row__input-container">
        <slot></slot>
        <FormRowErrors :errors="errors" v-if="!lateral" />
      </div>
    </div>
    <FormRowErrors :errors="errors" v-if="lateral" />
  </div>
</template>

<script setup>
import { computed } from 'vue';

import joinClasses from '@/functions/join_classes';

import FormRowErrors from '@/components/form/row_errors.vue';

const props = defineProps({
  label: { type: String, default: null },
  errors: { type: Array, default: null },
  modifiers: { type: Array, default: () => [] },
  labelFor: { type: String, default: null },
});

const lateral = computed(() => {
  return props.modifiers.includes('lateral');
});
</script>
